import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sustainable-dialog',
  templateUrl: './sustainable-dialog.component.html',
  styleUrls: ['./sustainable-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class SustainableDialogComponent implements OnInit, OnDestroy {
  public title = '';
  public content = '';

  constructor(
    private activeModal: NgbActiveModal,
    private router: Router
  ) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  close() {
    this.activeModal.close();
  }

  redirect() {
    this.router.navigate(['/sustainability']);
    this.close();
  }
}
